import { FC } from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material"
import { ExpandMore } from "@mui/icons-material"

/**
 * Сворачиваемая help-панель оператора (ТЗ §7). Текст на русском.
 */
export const OperatorHelp: FC = () => (
  <Accordion sx={{ mb: 2 }}>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography fontWeight={600}>Как это работает</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography paragraph>
        <b>Гостевые боты Telegram</b> — бот отвечает одним сообщением, когда его
        упоминают (<code>@бот</code>) в публичной или приватной группе. Ответ
        настраивается по тексту запроса - триггеру.
      </Typography>

      <Typography fontWeight={600} gutterBottom>
        Как настроить:
      </Typography>
      <List dense sx={{ listStyleType: "decimal", pl: 4 }}>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Создайте шаблоны ответов на вкладке «Шаблоны» (текст / фото / документ, кнопки, форматирование)." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Добавьте бота: вставьте токен и укажите задержку ответа (0–180 сек)." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Откройте бота и задайте привязки: текст-триггер → шаблон. Пустой триггер = ответ по умолчанию (fallback)." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Проверьте статус: working — бот на связи; banned — неверный/отозванный токен (обновите токен и включите заново)." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Смотрите срабатывания на вкладке «Логи»." />
        </ListItem>
      </List>

      <Typography fontWeight={600} gutterBottom>
        Про задержку ответа.
      </Typography>
      <Typography paragraph>
        Задержка — это пауза между упоминанием бота и его ответом. Она нужна,
        чтобы ответ бота было сложнее связать с конкретным сообщением
        пользователя. Типичный сценарий:
      </Typography>
      <List dense sx={{ listStyleType: "decimal", pl: 4 }}>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Пользователь упоминает бота (@бот) в чате." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Пользователь удаляет своё сообщение." />
        </ListItem>
        <ListItem sx={{ display: "list-item" }} disableGutters>
          <ListItemText primary="Через 2–3 минуты (заданная задержка) бот отправляет ответ в чат — уже без видимой привязки к исходному сообщению." />
        </ListItem>
      </List>

      <Typography>Совпадение триггера точное, регистр не важен.</Typography>
    </AccordionDetails>
  </Accordion>
)
